import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default class Form extends React.Component {
  formState = FormState.create(this);
  state = {};

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork(); // this is so java
    context.set(name, value).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { formDisabled, langSwitcher, uuid, wasSent } = this.props;
    const errors = populateFormErrors(this.formState);

    return (
      <section className="login">
        <div className="c-floating">
          {langSwitcher &&
          <div className="c-floating__head">
            <span />
            <LanguageSwitcher />
          </div>
          }
          <FormStateForm formState={this.formState} className="c-floating__body" onSubmit={this.onSubmit}>
            <fieldset disabled={formDisabled}>
              <h1 className="new-campaign__header">Nové heslo</h1>

              { wasSent
                ? <div>
                  <p className="c-para">
                    <strong>Heslo bolo úspešne zmenené.</strong>
                  </p>
                  <a href="/p2p/prihlasenie/" type="submit" className="c-button c-button--primary new-campaign__button">
                    <span className="c-button__content">
                      <span className="text-icon">
                        <span className="text-icon__text">Prihlásenie</span>
                        <i className="icon-arrow-forward text-icon__icon"/>
                      </span>
                    </span>
                  </a>
                </div>
                : <div>
                    <label className="c-input__wrapper">
                    <span className="c-input__label">E-mailová adresa</span>
                    <span className={classNames(
                      'c-input__border', 'new-campaign__input-text',
                      { 'c-input__border--error': errors.email }
                    )}>
                      <WiredInput
                        name="email"
                        className="c-input"
                        onChange={this.onInputChange}
                        autoFocus
                        validator={v => v
                          .email().msg('passwordReset.form.errors.email.email')
                          .required().msg('passwordReset.form.errors.email.required')
                        }
                      />
                    </span>
                    <ValidationMessage msg={errors.email} />
                  </label>
                  <p className="c-para">Zadajte po sebe 2× nové heslo.</p>

                  <label className="c-input__wrapper">
                  <span className="c-input__label">Heslo</span>
                  <span className={classNames(
                    'c-input__border', 'new-campaign__input-text',
                    { 'c-input__border--error': errors.password }
                  )}>
                    <WiredInput
                      name="password"
                      className="c-input"
                      type="password"
                      validator={
                        v => v.required().msg('passwordReset.form.errors.password.required')
                          .minLength(8).msg('passwordReset.form.errors.password.length')
                          .maxLength(100).msg('passwordReset.form.errors.password.length')
                      }
                      onChange={this.onInputChange}
                    />
                  </span>
                  <ValidationMessage msg={errors.password} />
                </label>

                <label className="c-input__wrapper">
                  <span className="c-input__label">Heslo ešte raz</span>
                  <span className={classNames(
                    'c-input__border', 'new-campaign__input-text',
                    { 'c-input__border--error': errors.passwordRepeat }
                  )}>
                    <WiredInput
                      name="passwordRepeat"
                      className="c-input"
                      type="password"
                      revalidateOnSubmit
                      validator={(v, context) => {
                        const password = context.getFieldState('password').getValue();
                        return password
                          ? v.required().msg('passwordReset.form.errors.passwordRepeat.required')
                              .minLength(8).msg('passwordReset.form.errors.password.length')
                              .maxLength(100).msg('passwordReset.form.errors.password.length')
                              .equals(context.getFieldState('password').getValue()).msg('passwordReset.form.errors.passwordRepeat.equals')
                          : v;
                      }
                      }
                      onChange={this.onInputChange}
                    />
                  </span>
                  <ValidationMessage msg={errors.passwordRepeat} />
                </label>

                  <button type="submit" className="c-button c-button--primary new-campaign__button">
                  <span className="c-button__content">
                  <span className="text-icon">
                  <span className="text-icon__text">Nastaviť nové heslo</span>
                  <i className="icon-arrow-forward text-icon__icon" />
                  </span>
                  </span>
                  </button>
                </div>
              }
            </fieldset>
          </FormStateForm>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/passwordReset/ConfirmForm.js